import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Key"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-key',
    templateUrl: './icon-key.component.html',
    styleUrls: ['./icon-key.component.scss'],
    standalone: false
})
export class IconKeyComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
